import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Spin, Select } from 'antd';
import H3Text from '@Uilib/h3Text';
import './style.scss';

function MetricSalesPieChart({
  data, loading, title, type, MONEY,
}) {
  const seriesData = data.map((cat) => (type === 'CATEGORY' ? parseInt(cat.category_sales) : parseInt(cat.state_sales)));
  const labels = data.map((cat) => (type === 'CATEGORY' ? cat.product_category_name || 'Others' : cat.shipping_state || 'Others'));
  const handleSegmentClick = (event, chartContext, config) => {

  };

  const chartOptions = {
    chart: {
      id: type,
      type: 'pie',
      height: 250,
      events: {
        dataPointSelection: handleSegmentClick,
      },
    },
    series: seriesData,
    labels,
    legends: {
      floating: false,

    },
    tooltip: {
      custom: ({
        series, seriesIndex, dataPointIndex, w,
      }) => {
        const item = series[seriesIndex];
        const color = w.globals.colors[seriesIndex];
        const label = w.globals.labels[seriesIndex];
        return (
          `<div class="tooltip-value">
            <div class="tooltip-value__content">
              <div class="tooltip-value__row" style="display: flex; gap: 8px; align-items: center; padding: 4px;">
                <div style="background-color: ${color}; width: 10px; height: 10px;" class="tooltip-value__bullet"></div>
                <h3 class="tooltip-value__name" style="margin: 0;">${label}</h3>
                <h3 class="tooltip-value__count" style="margin: 0;">${MONEY(item)}</h3>
              </div>
            </div>
          </div>`
        );
      },
    },
  };

  return (
    <div className="metric-pie__loader">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-pie">
        <div className="metric-pie__title-wrapper">
          <H3Text text={title} className="metric-pie__title" />
          {/* <Select
            onChange={(value) => setType(value)}
            defaultValue="CATEGORY"
            bordered={false}
            options={[
              {
                value: 'CATEGORY',
                label: 'Category',
              },
              {
                value: 'STATE',
                label: 'State',
              },
            ]}
          /> */}
        </div>
        <div className="metric-pie__content">
          <div className="metric-pie__chart">
            <ReactApexChart options={chartOptions} height={250} type="pie" series={seriesData} />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({});

MetricSalesPieChart.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  title: PropTypes.string,
  selectedTenant: PropTypes.string,
  fromDate: PropTypes.any,
  toDate: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricSalesPieChart));
